/**
 * @file     footerCities.ts
 * @purpose  The city links the footer renders sitewide. Stands apart from cities.ts so the client-rendered footer does not pull the full CityConfig corpus (long descriptions, FAQs) into every page bundle.
 */

/**
 * Highest-inventory cities, in order. Deliberately short: a 40-city block on
 * every page is boilerplate that gets discounted and dilutes the per-page link
 * graph. The complete index lives on /british-columbia and on the homepage
 * browse hub. Every slug here must exist in CITIES so `/properties/{slug}`
 * resolves to a city landing page rather than a listing lookup.
 */
export const FOOTER_CITIES: readonly { slug: string; name: string }[] = [
  { slug: 'surrey', name: 'Surrey' },
  { slug: 'vancouver', name: 'Vancouver' },
  { slug: 'burnaby', name: 'Burnaby' },
  { slug: 'richmond', name: 'Richmond' },
  { slug: 'langley', name: 'Langley' },
  { slug: 'coquitlam', name: 'Coquitlam' },
  { slug: 'north-vancouver', name: 'North Vancouver' },
  { slug: 'maple-ridge', name: 'Maple Ridge' },
];
